import { Route } from '@angular/router';

import { CalendarComponent } from 'app/modules/calendar/calendar.component';
import { CalendarSettingsResolver } from 'app/modules/calendar/calendar.resolvers';
import { ProjectDataResolver } from '../projects/projects.resolvers';

export const calendarRoutes: Route[] = [
  {
    path: '',
    component: CalendarComponent,
    resolve: {
      options: ProjectDataResolver,
      settings: CalendarSettingsResolver,
    },
  },
];
